(function() { window.GUID_6ace5f21_a611_41fd_bf2f_98ab5ec9223a = { getGuid: function() { return "6ace5f21-a611-41fd-bf2f-98ab5ec9223a"; } }; })();
var CompuSport;
(function (CompuSport) {
    let Ajax;
    (function (Ajax) {
        let AjaxCallType;
        (function (AjaxCallType) {
            AjaxCallType[AjaxCallType["GET"] = 0] = "GET";
            AjaxCallType[AjaxCallType["POST"] = 1] = "POST";
        })(AjaxCallType = Ajax.AjaxCallType || (Ajax.AjaxCallType = {}));
        function Get(url, data, callback, errorCallBack) {
            Call(false, url, "GET", false, data, callback, errorCallBack);
        }
        Ajax.Get = Get;
        function Post(url, data, callback, errorCallBack) {
            Call(false, url, "POST", true, data, callback, errorCallBack);
        }
        Ajax.Post = Post;
        function PostForm(url, data, callback, errorCallBack) {
            Call(true, url, "POST", true, data, callback, errorCallBack);
        }
        Ajax.PostForm = PostForm;
        function GetBlob(url, data, callback, errorCallBack) {
            data['getblob'] = true;
            Get(url, data, callback, errorCallBack);
        }
        Ajax.GetBlob = GetBlob;
        function GetBlobPost(url, data, callback, errorCallBack) {
            data['getblob'] = true;
            Post(url, data, callback, errorCallBack);
        }
        Ajax.GetBlobPost = GetBlobPost;
        function HandleAjaxError(xhr, see, err, errorCallBack) {
            /*Si navigation, ca pete le ajax et throw une erreur non souhaitable, donc, ne pas en tenir compte*/
            if (CompuSport != undefined &&
                CompuSport.DOM != undefined &&
                CompuSport.DOM.Navigating != undefined) {
                if (CompuSport.DOM.Navigating) {
                    return;
                }
            }
            if (errorCallBack != null) {
                errorCallBack(xhr, see, err);
            }
            if (see.statusText == "abort") {
                return;
            }
            var isAccesDenied = false;
            if (xhr.responseText != undefined && xhr.responseText != "") {
                CompuSport.DOM.body.find('#CSError').remove();
                var csError = $('<div id="CSError"></div>');
                csError.append(xhr.responseText);
                CompuSport.DOM.body.append(csError);
                $('#CSError').show();
            }
            if (isAccesDenied) {
                window.location.replace(CSParameters.RUrl + "Account/Login/" + CSParameters.SportEventId + "?returnUrl=" + CSParameters.ReturnUrlEncoded);
                return;
            }
        }
        function HandleAjaxSuccess(response, jqXHR, callback) {
            if (typeof CS !== 'undefined' && typeof CS.UserHangfireTasks !== 'undefined' && typeof CS.UserDisclaimer !== 'undefined') {
                CS.UserHangfireTasks.CheckIfAnyTasks(jqXHR);
                CS.UserDisclaimer.CheckIfAnyDisclaimer(jqXHR);
            }
            let $response;
            try {
                $response = $(response);
                if (response.NotFound != undefined) {
                    alert(response.error);
                    return;
                }
                if (callback != null) {
                    callback(response, jqXHR);
                }
                return;
            }
            catch (e) {
            }
            if (callback != null) {
                callback(response, jqXHR);
            }
        }
        function Call(postForm, url, ajaxCallType, needAntiforgery, data, callback, errorCallBack) {
            //Attention, ceci est important pour l'antiforgery parce qu'il regarde la casse de l'url
            url = url.toLowerCase();
            let antiforgeryTokenValue = $('input[name=__RequestVerificationToken]').last().val();
            if (data != null && data['getblob'] == true) {
                Ajax.CurrentAjaxCall = $.ajax({
                    cache: false,
                    type: ajaxCallType,
                    url: url,
                    data: data,
                    xhrFields: {
                        responseType: 'blob'
                    },
                    headers: { 'RequestVerificationToken': antiforgeryTokenValue },
                    success: function (response, status, xhr) {
                        var filename = "";
                        var disposition = xhr.getResponseHeader('Content-Disposition');
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            var matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1])
                                filename = matches[1].replace(/['"]/g, '');
                        }
                        var blob = new Blob([response], { type: xhr.getResponseHeader('Content-Type') });
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename || 'download';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        if (callback != null) {
                            callback(response, xhr);
                        }
                    },
                    error: function (xhr, status, error) {
                        HandleAjaxError(xhr, status, error, errorCallBack);
                    }
                });
            }
            else if (postForm) {
                Ajax.CurrentAjaxCall = $.ajax({
                    cache: false,
                    type: ajaxCallType,
                    url: url,
                    data: data,
                    contentType: false,
                    processData: false,
                    headers: { 'RequestVerificationToken': antiforgeryTokenValue },
                    success: function (response, status, xhr) {
                        HandleAjaxSuccess(response, xhr, callback);
                    },
                    error: function (xhr, status, error) {
                        HandleAjaxError(xhr, status, error, errorCallBack);
                    }
                });
            }
            else {
                Ajax.CurrentAjaxCall = $.ajax({
                    cache: false,
                    type: ajaxCallType,
                    url: url,
                    data: data,
                    headers: { 'RequestVerificationToken': antiforgeryTokenValue },
                    success: function (response, status, xhr) {
                        HandleAjaxSuccess(response, xhr, callback);
                    },
                    error: function (xhr, status, error) {
                        HandleAjaxError(xhr, status, error, errorCallBack);
                    }
                });
            }
        }
    })(Ajax = CompuSport.Ajax || (CompuSport.Ajax = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Ajax.js.map
